<template>
  <div class="chartPage">
    <!-- <div class="checkBtn" id="checkBtn" @click="checkChart">横向显示</div> -->
    <div v-if="update" id="myChart"></div>
    <!-- <van-popup v-model="showCheckChart" class="CheckPopup" :closeable="true">
      <check-chart :checkData="chartData"></check-chart>
    </van-popup>-->
  </div>
</template>
<script>
/* eslint-disable */
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
const checkChart = () => import("@/components/treeModule/checkChart");
export default {
  name: "lineChart",
  // props: ["chartData"],
  props: {
    chartData: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  components: {
    checkChart,
  },
  data() {
    return {
      sensorType: "",
      machineAddress: "",
      sensorTypeName: "",
      sensorUnitType: "",
      xData: [],
      yData: [],
      update: true,
      showCheckChart: false, //是否显示横屏
    };
  },
  mounted() {
    if (this.chartData.sensorType && this.chartData.machineAddress) {
      this.sensorType = this.chartData.sensorType;
      this.machineAddress = this.chartData.machineAddress;
      this.sensorTypeName = this.chartData.sensorTypeName;
      this.sensorUnitType = this.chartData.sensorUnitType;
      this.getSource();
    }

    window.addEventListener(
      "onorientationchange" in window ? "orientationchange" : "resize",
      this.renderResize,
      false
    );
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener("resize", this.renderResize, false);
  },
  methods: {
    renderResize() {
      // 判断横竖屏
      this.update = false;
      if (window.orientation == 90 || window.orientation == -90) {
        //横屏
        this.drawLine(1);

        this.update = true;
      } else {
        //竖屏
        this.drawLine(2);

        this.update = true;
      }
      // 做页面适配
      // 注意：renderResize方法执行时虚拟dom尚未渲染挂载，如果要操作vue实例，最好在this.$nextTick()里进行。
    },
    getSource() {
      //获取折线图数据
      let _this = this;
      _this.$api.slbkOldTree
        .reportData({
          machineAddress: _this.machineAddress,
          sensorType: _this.sensorType,
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            let xSource = [];
            xSource = res.data.xaxises;
            xSource.forEach(SelectTime);
            function SelectTime(item, index) {
              _this.xData.push(item.substr(10, 12));
            }
            _this.yData = res.data.yaxises;
            this.renderResize();
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    drawLine(type) {
      //构建折线图
      let _this = this;

      // 基于准备好的dom，初始化echarts实例
      let myChart = _this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      let optionOne = {
        title: {
          text: this.sensorTypeName + "：最近24小时数据",
          x: "center",
          y: "top",
          textStyle: {
            fontWeight: "normal", //标题颜色
            color: "#9f9f9f",
            fontSise: "18px",
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let color = params.color; //图例颜色
            let htmlStr = "<div>";
            htmlStr += "时间：" + params[0].axisValue + ":00<br/>"; //x轴的名称
            //为了保证和原来的效果一样，这里自己实现了一个点的效果
            htmlStr += "<span ></span>";
            //添加一个汉字，这里你可以格式你的数字或者自定义文本内容
            htmlStr +=
              params[0].seriesName +
              "：" +
              Number(params[0].value).toFixed(1) +
              _this.sensorUnitType;
            htmlStr += "</div>";
            return htmlStr;
          },
        },
        xAxis: [
          {
            axisLabel: {
              type: "category",
              interval: 3,
            },
            axisTick: {
              inside: true,
            },
            axisLine: {
              //坐标 轴线
              lineStyle: {
                color: "#333",
                width: 2,
                shadowColor: "#32b17a", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 0.6,
              },
              onZero: false,
            },
            data: _this.xData,
            name: "单位（h）",
          },
        ],
        yAxis: {
          type: "value",
          name: "单位（" + _this.sensorUnitType + "）",
          axisTick: {
            inside: true,
          },
          scale: true,
          axisLine: {
            lineStyle: {
              color: "#333",
              width: 2,
              shadowColor: "#32b17a", //阴影颜色
              shadowOffsetX: 0, //阴影水平方向上的偏移距离。
              shadowOffsetY: 0, //阴影垂直方向上的偏移距离
              shadowBlur: 10, //图形阴影的模糊大小。
              opacity: 0.6,
            },
          },
          splitLine: {
            show: false,
          },
          splitArea: {
            //坐标轴在 grid 区域中的分隔区域，默认不显示。
            interval: "auto",
            show: false, //是否显示分隔区域
            areaStyle: {
              color: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
              shadowColor: "red", //阴影颜色
              shadowOffsetX: 0, //阴影水平方向上的偏移距离。
              shadowOffsetY: 0, //阴影垂直方向上的偏移距离
              shadowBlur: 10, //图形阴影的模糊大小。
              opacity: 1, //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
            },
          },
        },

        grid: {
          left: 20,
          right: 70,
          containLabel: true,
        },
        series: [
          {
            name: _this.sensorTypeName,
            type: "line",
            data: _this.yData,
            smooth: true,
            // symbol: "circle",
            showSymbol: false,
            symbolSize: 5,
            sampling: "average",
            itemStyle: {
              normal: {
                color: ["#32b17a"],
                lineStyle: {
                  width: 3,
                },
              },
            },
            areaStyle: {
              color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(82,206,86,0.8)",
                },
                {
                  offset: 0.4,
                  color: "rgba(82,206,86,0.3)",
                },
                {
                  offset: 1,
                  color: "rgba(82,206,86,0.00)",
                },
              ]),
            },
          },
        ],
      };
      let optionTwo = {
        title: {
          text: this.sensorTypeName + "：最近24小时数据",
          x: "center",
          y: "center",
          textStyle: {
            fontWeight: "normal", //标题颜色
            color: "#9f9f9f",
            fontSise: "18px",
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var color = params.color; //图例颜色
            var htmlStr = "<div>";
            htmlStr += "时间：" + params[0].axisValue + ":00<br/>"; //x轴的名称
            //为了保证和原来的效果一样，这里自己实现了一个点的效果
            htmlStr += "<span ></span>";
            //添加一个汉字，这里你可以格式你的数字或者自定义文本内容
            htmlStr +=
              params[0].seriesName +
              "：" +
              Number(params[0].value).toFixed(1) +
              _this.sensorUnitType;
            htmlStr += "</div>";
            return htmlStr;
          },
        },
        xAxis: [
          {
            axisLabel: {
              type: "category",
              interval: 3,
            },
            axisTick: {
              inside: true,
            },
            axisLine: {
              //坐标 轴线
              lineStyle: {
                color: "#333",
                width: 2,
                shadowColor: "#32b17a", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 0.6,
              },
              onZero: false,
            },
            data: _this.xData,
            name: "单位（h）",
          },
        ],
        yAxis: {
          type: "value",
          name: "单位（" + _this.sensorUnitType + "）",
          axisTick: {
            inside: true,
          },
          scale: true,
          axisLine: {
            lineStyle: {
              color: "#333",
              width: 2,
              shadowColor: "#32b17a", //阴影颜色
              shadowOffsetX: 0, //阴影水平方向上的偏移距离。
              shadowOffsetY: 0, //阴影垂直方向上的偏移距离
              shadowBlur: 10, //图形阴影的模糊大小。
              opacity: 0.6,
            },
          },
          splitLine: {
            show: false,
          },
          splitArea: {
            //坐标轴在 grid 区域中的分隔区域，默认不显示。
            interval: "auto",
            show: false, //是否显示分隔区域
            areaStyle: {
              color: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
              shadowColor: "red", //阴影颜色
              shadowOffsetX: 0, //阴影水平方向上的偏移距离。
              shadowOffsetY: 0, //阴影垂直方向上的偏移距离
              shadowBlur: 10, //图形阴影的模糊大小。
              opacity: 1, //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
            },
          },
        },
        grid: {
          left: 20,
          right: 70,
          top: 90,
          bottom: 10,
          containLabel: true,
        },
        series: [
          {
            name: _this.sensorTypeName,
            type: "line",
            data: _this.yData,
            smooth: true,
            // symbol: "circle",
            showSymbol: false,
            symbolSize: 5,
            sampling: "average",
            itemStyle: {
              normal: {
                color: ["#32b17a"],
                lineStyle: {
                  width: 3,
                },
              },
            },
            areaStyle: {
              color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(82,206,86,0.8)",
                },
                {
                  offset: 0.4,
                  color: "rgba(82,206,86,0.3)",
                },
                {
                  offset: 1,
                  color: "rgba(82,206,86,0.00)",
                },
              ]),
            },
          },
        ],
      };
      if (type == "1") {
        myChart.clear();
        //  myChart.reload();
        var deviceType = getDeviceType();
        if (deviceType == "android") {
          document.getElementById("myChart").style.height = "100%";
          document.getElementById("myChart").style.width = "100%";
        } else {
          document.getElementById("myChart").style.height = "365px";
          document.getElementById("myChart").style.width = "500px";
        }

        myChart.setOption(optionTwo, true);
        window.onresize = myChart.resize;
      } else if (type == "2") {
        myChart.clear();
        // myChart.reload();
        document.getElementById("myChart").style.width = "365px";
        document.getElementById("myChart").style.height = "500px";

        myChart.setOption(optionOne, true);
        window.onresize = myChart.resize;
      }
    },

    checkChart() {
      this.showCheckChart = true;
    },
  },
  watch: {
    chartData: {
      handler: function () {
        let _this = this;
        _this.sensorType = _this.chartData.sensorType;
        _this.machineAddress = _this.chartData.machineAddress;
        _this.sensorTypeName = _this.chartData.sensorTypeName;
        _this.sensorUnitType = _this.chartData.sensorUnitType;
        _this.xData = [];
        _this.yData = [];
        _this.getSource();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.chartPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow: hidden;
  .checkBtn {
    position: absolute;
    top: 15px;
    right: 10px;
    padding: 5px 5px;
    background-color: #32b17a;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
  }
  #myChart {
    width: 100%;
    height: 500px;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: #fff;
  }
  .van-overlay {
    display: none;
  }
  .CheckPopup {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    transform: none;
    background-color: rgba(0, 0, 0, 0);
    .van-popup__close-icon {
      color: #000 !important;
    }
    .van-popup__close-icon.van-popup__close-icon--top-right {
      top: initial;
      left: initial;
      bottom: 10px;
      right: 10px;
      color: #000 !important;
    }
  }
}
</style>    
